import { Category, ResourceCategory, TaxonomyTerm } from '../../domain/entities/category';

import {
  asArray,
  asRecord,
  readBoolean,
  readId,
  readLocalized,
  readRecord,
  readString,
} from './raw-json';

export function toCategory(raw: unknown): Category | null {
  const record = asRecord(raw);
  const id = readId(record);
  const name = readLocalized(record, 'label', 'name', 'title');

  if (id === null || name === null) {
    return null;
  }
  return { id, name };
}

export function toResourceCategory(raw: unknown, index: number): ResourceCategory | null {
  const category = toCategory(raw);
  if (category === null) {
    return null;
  }
  const record = asRecord(raw);
  const isPrimary = readBoolean(record, 'isPrimary', 'is_primary', 'primary');

  return {
    ...category,
    vocabulary: readString(record, 'vocabulary', 'vocabulario', 'taxonomy'),
    isPrimary: isPrimary ?? index === 0,
  };
}

function toTaxonomyTerm(raw: unknown, vocabulary: string): TaxonomyTerm | null {
  const category = toCategory(raw);
  if (category === null) {
    return null;
  }
  return { ...category, vocabulary: readString(asRecord(raw), 'vocabulary') ?? vocabulary };
}

export function toTaxonomy(payload: unknown): readonly TaxonomyTerm[] {
  const record = asRecord(payload);
  const taxonomy =
    readRecord(record, 'taxonomy') ?? readRecord(asRecord(record['data']), 'taxonomy');

  if (taxonomy === null) {
    return [];
  }

  return Object.keys(taxonomy).flatMap((vocabulary) =>
    asArray(taxonomy[vocabulary])
      .map((raw) => toTaxonomyTerm(raw, vocabulary))
      .filter((term): term is TaxonomyTerm => term !== null),
  );
}
